import styled from 'styled-components';

const QuadrantWrapper = styled.g`
  opacity: 1;
`;

export { QuadrantWrapper };
